import { useCallback, useEffect, useState } from 'react';

import mainAPI from '../utils/mainAPI';

import useStore from '../hooks/useStore';
import { toast } from 'react-toastify';

const primaryAccessRoles = ['admin', 'farmer'];

export const useDomainsStore = () => {
  const { appStore } = useStore();

  const userRoles = appStore.getUserRoles();

  const [apiKeys, setApiKeys] = useState({
    hasKeys: null,
    apiTypes: [],
    serverNames: {},
  });
  const [apiType, setApiType] = useState('');
  const [serverName, setServerName] = useState('');
  const [userName, setUserName] = useState(appStore.getUserName());

  const [buyersList, setBuyersList] = useState([]);

  const [userList, setUserList] = useState([]);

  const isPrimaryAccess = primaryAccessRoles.some((role) => userRoles.includes(role));

  const checkUserKeys = useCallback(async () => {
    try {
      const response = await mainAPI.get('/domains-store/keys', {
        params: { userName },
      });

      setApiKeys(response.data);

      if (response.data.apiTypes && response.data.apiTypes.length > 0) {
        const defaultType = response.data.apiTypes[0];
        setApiType(defaultType);

        if (
          response.data.serverNames &&
          response.data.serverNames[defaultType] &&
          response.data.serverNames[defaultType].length > 0
        ) {
          setServerName(response.data.serverNames[defaultType][0]);
        } else {
          setServerName('');
        }
      } else {
        setApiType('');
        setServerName('');
      }
    } catch (error) {
      console.error('Ошибка при проверке API-ключей:', error);
      setApiKeys({
        hasKeys: false,
        apiTypes: [],
        serverNames: {},
      });
      setApiType('');
      setServerName('');
    }
  }, [userName]);

  useEffect(() => {
    checkUserKeys();
  }, [userName, isPrimaryAccess, checkUserKeys]);

  const getUsers = async () => {
    try {
      const response = await mainAPI.get('/primary/all-users');
      setUserList(response.data);
    } catch (error) {
      console.error('Error fetching users for addApiKeysModal:', error);
    }
  };

  useEffect(() => {
    getUsers();
  }, []);

  const getBuyersList = useCallback(async () => {
    if (!isPrimaryAccess) {
      return;
    }

    try {
      const response = await mainAPI.get('/domains-store/buyers');
      setBuyersList(response.data.buyers);
    } catch (error) {
      console.error('Ошибка при получении списка баеров:', error);
      setBuyersList([]);
    }
  }, [isPrimaryAccess]);

  useEffect(() => {
    getBuyersList();
  }, [isPrimaryAccess, getBuyersList]);

  const createApiKeys = useCallback(async ({ buyer, apiType, serverName, ...apiFields }) => {
    try {
      const response = await mainAPI.post('/domains-store/api-keys', {
        buyer,
        apiType,
        serverName,
        ...apiFields,
      });

      if (response.data.success) {
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error('Ошибка при создании API-ключей:', error);
      toast.error('Ошибка при создании API-ключей');
    }
  }, []);

  return {
    apiKeys,
    userName,
    buyersList,
    isPrimaryAccess,
    apiType,
    serverName,
    userList,
    setApiType,
    setServerName,
    setUserName,
    createApiKeys,
  };
};
